import MojitoServices from 'mojito/services';

import {mergeToHierarchy} from '#core/utils/config-utils.js';
import {loadStyle} from '#core/utils/utils.js';
import {absoluteUrlToInternalResource} from '#core/utils/url-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './betradar.schema.yaml';

const {notificationEventResolverService} = MojitoServices.SportsContent.NotificationEvent;

class BetradarFeature extends AbstractFeature {
    get name() {
        return 'Betradar';
    }

    get configSchema() {
        return SCHEMA;
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        mergeToHierarchy(mojitoConfig, 'services.configurations.BetradarMatchTracker', {
            widgetLoaderUrl: this.config.widgetURL,
            widgetLoaderConfig: this.config.widgetLoaderConfig,
            fallbackLanguage: this.config.fallbackLanguage,
            widgetConfig: this.config.widgetConfig,
            languagesMapping: this.config.languagesMapping,
        });

        mergeToHierarchy(mojitoConfig, 'services.configurations.InplayEventController', {
            notificationsIdSearchParam: {
                name: 'provider',
                value: 'betradar',
            },
        });

        mergeToHierarchy(mojitoConfig, 'services', {
            notificationEventResolverService,
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }

    beforeMount(containerEl) {
        if (this.config.widgetLoaderConfig?.theme === false) {
            loadStyle(absoluteUrlToInternalResource('betradar-theme.css'), containerEl);
        }
        return super.beforeMount(containerEl);
    }
}

export const Betradar = new BetradarFeature(allFeatures);
